import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Storage } from '@ionic/storage';
import { SfClaimRequestNestApi } from '../../../shared/nestjs/gd-only/services/sf-claim-request.api';
import { NestApiProvider } from '../../../shared/nestjs/nest-api';
import { map } from 'rxjs/operators';
import {
  RequestClaimGetTypeDto,
  RequestEditClaimDto,
  ResponseClaimGetTypeDto
} from '../../../shared/nestjs/gd-only/dto/sf-claim-request.dto';
import { SFClaimRequestApi } from '../../../shared/sdk/services/custom';
import { ClaimApiOnly } from '../../../shared/nestjs/gd-all-in-one/services/claim.api';
import { FileUploaderProvider, OptionsUploadWithHttp } from '../../../providers/file-uploader/file-uploader';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { CameraOptions } from '@ionic-native/camera';
import { CameraSource, CameraNative } from '../../../native/camera.native';
import { GDAuthInterface } from '../../../model/gd-auth';
@Injectable()
export class ClaimBloc {
  private subscriptions: Array<Subscription> = [];

  constructor(
    public nestApiProvider: NestApiProvider,
    private translate: TranslateService,
    private http: HttpClient,
    private storage: Storage,
    private sfClaimRequestNestApi: SfClaimRequestNestApi,
    private SFClaimRequestApi: SFClaimRequestApi,
    private claimProvider: ClaimApiOnly,
    private fileUploaderProvider: FileUploaderProvider,
    private storagePathProvider: StoragePathProvider,
    private cameraNative: CameraNative
  ) {
  }

  async upload(options: OptionsUploadWithHttp, customFileName?: string) {
    try {
      const storage = await this.storagePathProvider.getStorageClaimNest(options.userid);
      let result;
      if (customFileName) {
        result = await this.fileUploaderProvider.uploadWithHttp(options, storage.urlUpload, true, customFileName);
      } else {
        result = await this.fileUploaderProvider.uploadWithHttp(options, storage.urlUpload);
      }
      return result;
    } catch (error) {
      throw error;
    }
  }

  async takePicture(isCamera: boolean) {
    try {
      const optionsCamera: CameraOptions = {
        sourceType: CameraSource.CAMERA,
        quality: 100,
        targetWidth: 1280,
        targetHeight: 1280,
        cameraDirection: 0,
        allowEdit: false
      }

      if (!isCamera) {
        optionsCamera.sourceType = CameraSource.PHOTOLIBRARY;
      }

      const camera = await this.cameraNative.getPicture(optionsCamera);
      return camera;
    } catch (error) {
      throw error;
    }
  }

  createFileName(params: { isCamera, path, SFGoAuth: GDAuthInterface }) {
    let filename = '';
    if (params.isCamera) {
      filename = params.SFGoAuth.companyCode + '_IMG_' + this.formatDate() + this.makeid() + '_' + params.SFGoAuth.userId + '_' + params.path.substr(params.path.lastIndexOf('/') + 1);
    } else {
      filename = params.SFGoAuth.companyCode + '_IMG_' + this.formatDate() + '_' + params.SFGoAuth.userId + '_' + this.makeid().toString() + '.jpg';
    }

    return filename;
  }

  formatDate() {
    let d = new Date(),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('');
  }

  makeid() {
    var text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for (let i = 0; i < 12; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  checkExtension(fileName: string) {
    let formatImage = fileName.substring(fileName.lastIndexOf('.') + 1);
    let res = formatImage.toLowerCase();

    if (res == 'jpg' || res == 'jpeg' || res == 'png' || res == 'svg' || res == 'gif') {
      return 'image';
    } else {
      return 'file';
    }
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  async getType(param: any) {
    return new Promise<Array<any>>((resolve, reject) => {
      this.subscriptions.push(
        this.apiGetType(param)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  async editClaim(payload: RequestEditClaimDto): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.claimProvider.editClaim(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  async deleteClaimSetting(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subscriptions.push(
        this.claimProvider.deleteClaimSetting(payload)
          .subscribe((result) => {
            resolve(result);
          }, error => {
            reject(error);
          })
      )
    })
  }

  private apiGetType(param): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          return this.sfClaimRequestNestApi.getType(param).pipe(map(response => response.data));
        } else {
          return this.SFClaimRequestApi.getType(param).pipe(map(response => response.hasil));
        }
      })
  }

  processWebFile(event): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const name = event.target.files[0].name;
      const size = event.target.files[0].size;
      if (size > 10000000) {
        reject(this.translate.instant('File Size Maximum 10MB'));
      } else {
        let base: any;
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          base = reader.result;
          resolve({
            data: base,
            fileName: name,
            eventsWebview: <Array<File>>event.target.files[0],
          });
        }, false);
        reader.readAsDataURL(event.target.files[0]);
      }

    })
  }

  sendUpload(file, url): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(url, formData);
  }

  async getSFGoAuth(): Promise<any> {
    return JSON.parse(await this.storage.get('SFGoAuth'));
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/claim/claim.bloc.ts